
import { Component, Emit, Vue, Prop } from 'vue-property-decorator'

@Component
export default class AppSwitch extends Vue {
    @Prop() private value!: boolean

    @Emit('input')
    public input(e: any) {
        return e.target.checked
    }
}
